<div #Aframe3dcontainer id="Aframe3dcontainer" style="height: 100%" [class.fullscreen]="fullscreen">
	<div id="loading-screen" [class.fade-out]="!loading">
		<div id="loader"></div>
	</div>
	<div class="sliderLight" *ngIf="guiEnabled">
		<fa-icon [icon]="['fas','sun']" style="margin: 0 13px"></fa-icon>
		<span class="sliderCustom">
			<ngx-slider [(value)]="directionalLightSlider.value" [options]="directionalLightSlider.options"
						(userChange)="updateDirectional($event)"
			></ngx-slider>
		</span>

		<fa-icon [icon]="['fas','moon']" style="margin: 0 13px"></fa-icon>
		<div ngbTooltip="Fullscreen" (click)="fullscreen  = !fullscreen" style="margin-top: 10px;cursor: pointer">
			<fa-icon [icon]="['fas','expand']" *ngIf="!fullscreen" style="margin: 0 13px"></fa-icon>
			<fa-icon [icon]="['fas','compress-alt']" *ngIf="fullscreen" style="margin: 0 13px"></fa-icon>
		</div>
	</div>
</div>
<!--
<div class="debugGui">
  <button [hidden]="!this.guiShown" style="float: right;z-index: 99999999;" (click)="this.toggleGui()">Hide debug gui
  </button>
  <button [hidden]="this.guiShown" style="float: right;z-index: 99999999;" (click)="this.toggleGui()">Show debug gui
  </button>
  <span [hidden]="!this.guiShown">
    <br/>
    <span class="guiSpan" *ngIf="this.camera">position: {{this.camera.position.x.toFixed(2)}}, {{this.camera.position.y.toFixed(2)}}, {{this.camera.position.z.toFixed(2)}}</span> <br/>

    <span class="guiSpan" *ngIf="this.camera">rotaion: {{this.camera.rotation.x.toFixed(2)}}, {{this.camera.rotation.y.toFixed(2)}}, {{this.camera.rotation.z.toFixed(2)}}</span> <br/>

    <span class="guiSpan" *ngIf="this.camera">fov:
      <ion-input type="number" [(ngModel)]="this.camera.fov" (ionChange)="this.setFov($event)"></ion-input>
    </span> <br/>

    <span class="guiSpan" *ngIf="this.fbxScale">scale:
      <ion-input type="number" min="0.01" [(ngModel)]="this.fbxScale"
                 (ionChange)="this.setFbxScale($event)"></ion-input>
    </span> <br/>

    <span class="guiSpan" *ngIf="this.parameters">sun inclination:
      <ion-input type="number" [(ngModel)]="this.parameters.inclination" (ionChange)="this.updateSun()"></ion-input>
    </span> <br/>

    <span class="guiSpan" *ngIf="this.parameters">sun azimuth:
      <ion-input type="number" [(ngModel)]="this.parameters.azimuth" (ionChange)="this.updateSun()"></ion-input>
    </span> <br/>

    <span class="guiSpan" *ngIf="this.directionalLight">Directional Light Intensity:
      <ion-input type="number" [(ngModel)]="this.directionalLight.intensity"></ion-input>
    </span> <br/>

    <span class="guiSpan" *ngIf="this.ambientLight">Ambient Light Intensity:
      <ion-input type="number" [(ngModel)]="this.ambientLight.intensity"></ion-input>
    </span> <br/>

    <span class="guiSpan" *ngIf="this.sceneObjCount">Model Object Count: {{this.sceneObjCount}}</span> <br/>

    <span class="guiSpan" *ngIf="this.gltfSize">Model Size: {{this.gltfSize}} MB</span> <br/>

    &lt;!&ndash;<span class="guiSpan" *ngIf="this.drawCalls">DrawCalls: {{this.drawCalls}}</span> <br/>&ndash;&gt;
    &lt;!&ndash;<span class="guiSpan" *ngIf="this.drawTriangles">Triangles: {{this.drawTriangles}}</span> <br/>&ndash;&gt;

  </span>
</div>
-->
